const organization = {
    require_membership: 'يجب أن يكون المستخدم عضوًا في المنظمة للمتابعة.',
};
export default Object.freeze(organization);
